<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- <h4 class="tip">*企业账户余量 为先充值再消费, *惠信宝 为先消费额度再还款恢复额度</h4> -->
    <div class="dataList" v-if="tableData.length">
      <el-card class="box-card" v-for="(item, index) in tableData" :key="index">
        <div slot="header" class="clearfix">
          <span>{{item.type}}</span>
          <el-button style="float: right; padding: 3px 0" type="text">余量： {{item.money}}</el-button>
        </div>
        <div style="margin:20px 0">
          账户名称： {{
          arrayByIdToNameStr({
          ArrayData: accountList,
          ID: item.admin_id,
          })
          }}
        </div>
        <div style="margin:20px 0">账户号码：{{item.vip_number}}</div>
        <!-- <div v-if="item.type == '惠信宝'">信用额度上限：{{item.max_limit}}</div> -->
        <div style="margin:20px 0">开通日期：{{item.create_time}}</div>
      </el-card>
      <ElTable
        style="width:100%"
        height="400px"
        :columns="listHeader"
        :tableData="tableDataRecord"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <el-empty description="暂未开通账户" v-else style="margin-top: 100px"></el-empty>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import {
  selectVipCard,
  addVipCard,
  updateVipCard,
  deleteVipCard,
  updateMoney,
  updateMaxLimit
} from "@/services/mall/vipCard";
import { selectVipcardRecoder } from "@/services/mall/vipcardRecode";
import { mapState } from "vuex";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
import { selectAdmin } from "@/services/system/user.js";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab,
    StoreToString
  },
  async created() {
    this.getListData();
    this.selectAccountList();
  },
  data() {
    return {
      arrayByIdToNameStr,
      sexList: [{ name: "男" }, { name: "女" }],
      vipCardList: [
        { id: 1, name: "企业账户余量" },
        { id: 2, name: "惠信宝" }
        // { id: 3, name: "次卡" },
      ],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: [],
      tableDataRecord: [],
      /* 弹窗 */
      dialogName: "",
      dialogType: "",
      dialogForm: {},
      dialogFormVisible: false,
      dialogMoneyVisible: false,

      moneyInfo: {
        // type: "", //0充值 1消费
        // money: "",
        // message: "",
      },

      accountList: [],
      dialogMaxLimitVisible: false,
      listHeader:[
        { label: "序号", type: "index", width: 80 },
        { label: "操作余量", prop: "amount", width: 150 },
        { label: "交易描述", prop: "message" },
        {
          label: "交易时间",
          prop: "create_time",
          width: 180,
        },
        { label: "剩余余量", prop: "balance", width: 180 },
      ]
      
    };
  },
  computed: {
    filterQueryFormItems,    
    ...mapState(["userInfo", "filterStoreList"])
  },
  watch: {},
  methods: {
    async selectAccountList() {
      const { data, code, count } = await selectAdmin({
        pageNumber: 1,
        pageSize: 1000,
        grade: "1,2"
      });
      if (code === 200) {
        this.accountList = data.map(item => {
          return {
            ...item,
            name: item.alias_name,
            id: item.id
          };
        });
      }
    },
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const result = await selectVipCard({
        ...listQuery,
        admin_id: this.userInfo.id,
        grade: this.userInfo.grade
      });
      if (result.code === 200) {
        this.tableData = result.data;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }

      const { data, code, count } = await selectVipcardRecoder({
        ...listQuery,
        admin_id: this.userInfo.id,
        grade: this.userInfo.grade
      });
      if (code === 200) {
        this.tableDataRecord = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },

    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 创建企业账户弹窗 */
    handleAdd(type) {
      this.dialogFormVisible = true;
      this.dialogType = 0;
      this.dialogForm = {};
    },

    /* 保存 */
    save() {
      if (
        !this.dialogForm.user_phone ||
        !this.dialogForm.user_name ||
        !this.dialogForm.type ||
        !this.dialogForm.admin_id
      ) {
        this.$message.error("请填写必填字段");
        return;
      }
      /* 账号格式校验 */
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.dialogForm.user_phone)) {
        this.$message.error("手机号格式错误");
        return;
      }
      if (this.dialogType == 0) {
        addVipCard({
          ...this.dialogForm,
          create_user: `后台账号${this.userInfo.username}(ID:${this.userInfo.id})创建`
        }).then(res => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.dialogFormVisible = false;
          }
        });
      }
      if (this.dialogType == 1) {
        updateVipCard(this.dialogForm).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
            this.dialogFormVisible = false;
          }
        });
      }
    },

    /* 1修改，2充值，3消费 */
    handleEdit(row, index) {
      if (index === 1) {
        this.dialogFormVisible = true;
        this.dialogType = 1; //编辑企业账户
      }
      this.moneyInfo = {};
      if (index === 2) {
        if (
          (row.type === "惠信宝" && row.max_limit == 0) ||
          (row.type === "惠信宝" && row.money >= row.max_limit)
        ) {
          this.$message.error("惠信宝未使用额度不需要还款");
          return;
        }
        this.dialogMoneyVisible = true;
        this.moneyInfo.type = 0;
      }
      if (index === 3) {
        this.dialogMoneyVisible = true;
        this.moneyInfo.type = 1;
      }
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },
    /* 充值与消费 */
    saveUpdateMoney() {
      if (!this.moneyInfo.money || this.moneyInfo.money == 0) {
        this.$message.error("请填写正确的余量");
        return;
      }
      updateMoney({
        ...this.dialogForm,
        money: this.moneyInfo.money,
        type: this.moneyInfo.type,
        // user_phone,
        //        vip_number,
        // admin_id
        cancel_id: `${this.userInfo.username}(后台账号ID:${this.userInfo.id})`,
        amount:
          this.moneyInfo.type == 1
            ? -this.moneyInfo.money
            : this.moneyInfo.money,
        message: this.moneyInfo.message
      }).then(res => {
        if (res.code === 200) {
          this.listQuery.pageNumber = 1;
          this.getListData();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogMoneyVisible = false;
        }
      });
    },

    handleMaxLimit(row) {
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.dialogMaxLimitVisible = true;
    },

    /* 调整总额度 */
    saveMaxLimit() {
      if (!this.moneyInfo.max_limit && this.moneyInfo.max_limit !== 0) {
        this.$message.error("请填写正确的余量");
        return;
      }
      updateMaxLimit({
        ...this.dialogForm,
        max_limit: this.moneyInfo.max_limit,
        type: this.moneyInfo.type,
        cancel_id: `${this.userInfo.username}(后台账号ID:${this.userInfo.id})`
      }).then(res => {
        if (res.code === 200) {
          this.listQuery.pageNumber = 1;
          this.getListData();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogMaxLimitVisible = false;
        }
      });
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm(`确定删除手机号为"${row.user_phone}"的账户吗?`, "禁用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res => {
        deleteVipCard({ id: row.id, vip_number: row.vip_number }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.dataList {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.box-card {
  width: 400px;
  margin: 10px 0px;
}
.tip {
  color: rgb(255, 106, 0);
}
</style>
